module.exports = __webpack_public_path__ + "img/7.9cf48748.svg";